import { reportCustomError } from './owlReporter'; // eslint-disable-line import/no-cycle
/* eslint-disable waimaie/no-direct-access-localstorage */

/**
 * 老壳子中通过 localStorage 写入的本地存储数据在重启壳子后会丢失，因此在壳子环境中需要调用 `wmSystemApi` 上提供的增强能力。
 */

/**
 * 读取本地存储（兼容新老壳子、浏览器）
 *
 * @param key 键名
 */
const getStorage = (key: string) => {
    let value: string | null | undefined = null;

    if (window.wmSystemApi) {
        value = window.wmSystemApi.getStorage(key);

        // 旧壳子不存在的key会返回 undefined，统一成 null
        if (typeof value === 'undefined') {
            value = null;
        }
        if (value !== null) {
            try {
                value = decodeURIComponent(value);
            } catch (err) {
                reportCustomError({
                    name: 'getStorage时decodeURIComponent异常',
                    message: `异常Key：${key}；异常值: ${value}；errorInfo: ${err}`,
                    category: 'jsError',
                    level: 'WARN',
                });
            }
        }
    } else {
        value = window.localStorage.getItem(key);
    }

    return value;
};

/**
 * 写入本地存储（兼容新老壳子、浏览器）
 *
 * @param key 键名
 * @param value 值
 */
const setStorage = (key: string, value: string) => {
    if (window.wmSystemApi) {
        window.wmSystemApi.setStorage(key, encodeURIComponent(String(value)));
    } else {
        window.localStorage.setItem(key, value);
    }
};

/**
 * 删除本地存储（兼容新老壳子、浏览器）
 *
 * **壳子中只是把对应 key 的值设置成了空字符串**
 *
 * @param key 要删除的键名
 */
const removeStorage = (key: string) => {
    if (window.wmSystemApi) {
        window.wmSystemApi.setStorage(key, '');
    } else {
        window.localStorage.removeItem(key);
    }
};

export { getStorage, setStorage, removeStorage };
